import { abTestCreate } from './abTestCreate';
import { abTestGroupCreate } from './abTestGroupCreate';
import { abTestGroupUpdate } from './abTestGroupUpdate';
import { abTestUpdate } from './abTestUpdate';
import { createAbTestGroupUser } from './createAbTestGroupUser';
import { deleteAbTestGroupUser } from './deleteAbTestGroupUser';
import { disableAbTestGroupUser } from './disableAbTestGroupUser';
import { fetchAbTest } from './fetchAbTest';
import { fetchAbTestGroupUsers } from './fetchAbTestGroupUsers';
import { fetchAbTestRecordsFromProd } from './fetchAbTestRecordsFromProd';
import { fetchAbTests } from './fetchAbTests';
import { fetchCrmAbTestTypes } from './fetchCrmAbTestTypes';
import { getTrialInfoFromLiveCall } from './getTrialInfoFromLiveCall';
import { getTrialRenderConfig } from './getTrialRenderConfig';
import { optOutOfFreeTrial } from './optOutOfFreeTrial';
import { updateAbTestGroupUser } from './updateAbTestGroupUser';
import { assignAbTestPerStrategy } from './assignAbTestPerStrategy';

export const abTestService = {
  abTestCreate,
  abTestGroupCreate,
  abTestGroupUpdate,
  abTestUpdate,
  createAbTestGroupUser,
  deleteAbTestGroupUser,
  disableAbTestGroupUser,
  fetchAbTest,
  fetchAbTestGroupUsers,
  fetchAbTestRecordsFromProd,
  fetchAbTests,
  fetchCrmAbTestTypes,
  getTrialInfoFromLiveCall,
  getTrialRenderConfig,
  optOutOfFreeTrial,
  updateAbTestGroupUser,
  assignAbTestPerStrategy,
};
